<template>
  <div>
    <b-row style="margin-bottom: 8px">
      <b-col cols="3">
        <vs-button
          style="border-radius: 5px"
          type="gradient"
          id="button-with-loading-yeni2"
          class="vs-con-loading__container"
          @click="acikFaturaListesiGuncelle()"
          >Tüm Faturaları Güncelle</vs-button
        >
      </b-col>
    </b-row>
    <b-row>
      <b-col cols="6">
        <vs-card>
          <div slot="header">
            <h3>Açık Faturalar</h3>
          </div>
          <b-row style="margin-bottom: 10px">
            <b-col lg="4" sm="6">
              <ButtonPrimary
                :title="filtretitle"
                :size="filtresize"
                @test-click="resetStateFatura"
                :color="filtrecolor"
              />
            </b-col>
          </b-row>

          <ag-grid-vue
            style="width: 100%; height: 500px"
            class="ag-theme-alpine"
            :defaultColDef="defaultColDef"
            :columnDefs="columnDefs"
            :rowSelection="rowSelection"
            :rowData="rowData"
            :localeText="localeText"
            :pagination="true"
            @grid-ready="onGridReady"
            @first-data-rendered="onFirstDataRendered"
          >
          </ag-grid-vue>
        </vs-card>
      </b-col>
      <b-col cols="6">
        <vs-card>
          <div slot="header">
            <h3>Aylara Göre Açık Faturalar</h3>
          </div>
          <b-row style="margin-bottom: 10px">
            <b-col lg="4" sm="6">
              <ButtonPrimary
                :title="filtretitle"
                :size="filtresize"
                @test-click="resetStateFaturaAy"
                :color="filtrecolor"
              />
            </b-col>
          </b-row>

          <ag-grid-vue
            style="width: 100%; height: 500px"
            class="ag-theme-alpine"
            :defaultColDef="defaultColDef"
            :columnDefs="columnDefsAylar"
            :rowSelection="rowSelection"
            :rowData="rowDataAylar"
            :localeText="localeText"
            :pagination="true"
            @grid-ready="onGridReadyAylar"
            @first-data-rendered="onFirstDataRendered"
          >
          </ag-grid-vue>
        </vs-card>
      </b-col>
    </b-row>
  </div>
</template>
<script>
import ButtonPrimary from "../components/crm-components/global-components/ButtonPrimary.vue";
import Store from "../../store/store";
import state from "../../store/state";
import { AgGridVue } from "ag-grid-vue";
import "ag-grid-community/dist/styles/ag-grid.css";
import "ag-grid-community/dist/styles/ag-theme-alpine.css";
import "ag-grid-enterprise";
import FinansalRaporDetayButon from "../components/crm-components/finans-components/FinansalRaporDetayButon.vue";
import FinansalRaporAylikDetayButon from "../components/crm-components/finans-components/FinansalRaporAylikDetayButon.vue";
export default {
  data() {
    return {
      filtresize: "small",
      filtretitle: "Filtrelemeyi Resetle",
      filtrecolor: "success",
      defaultColDef: {
        sortable: true,
        resizable: true,
      },
      columnDefs: null,
      columnDefsAylar: null,
      rowData: null,
      rowDataAylar: null,
      localeText: null,
      rowSelection: null,
    };
  },
  components: {
    ButtonPrimary,
    AgGridVue,
    FinansalRaporDetayButon,
    FinansalRaporAylikDetayButon,
  },
  created() {
    this.localeText = this.$store.state.account.AG_GRID_LOCALE_EN;
    this.rowSelection = "single";
  },

  methods: {
    acikFaturaListesiGuncelle() {
      var vm = this;
      vm.columnDefsGrm = [];
      const vs = this.$vs;
      const soap = require("soap");
      const url = state.sistemAddress;
      const args = {
        token: Store.state.tokenId,
      };

      soap.createClient(url, function (err, client) {
        client.rpAcikFaturaAylarGuncelle(args, function (err, result) {
          if (result.rpAcikFaturaAylarGuncelleResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }
          vm.veriler = JSON.parse(result.rpAcikFaturaAylarGuncelleResult);
          console.log(vm.veriler);
        });
      });
    },
    resetStateFaturaAy() {
      this.gridApi.setFilterModel(null);
      this.gelenfiltre = "";
      this.rpAcikFaturaAylar();
    },
    resetStateFatura() {
      this.gridApi.setFilterModel(null);
      this.gelenfiltre = "";
      this.rpAcikFaturalar();
    },
    currencyFormatter(currency, sign) {
      var sansDec = currency.toFixed(2);
      var formatted = sansDec.replace(/\B(?=(\d{3})+(?!\d))/g, ",");
      return sign + `${formatted}`;
    },
    onFirstDataRendered(params) {
      params.api.sizeColumnsToFit();
    },
    onGridReadyAylar(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.rpAcikFaturaAylar();
    },
    onGridReady(params) {
      this.gridApi = params.api;
      this.gridColumnApi = params.columnApi;
      this.rpAcikFaturalar();
    },
    rpAcikFaturaAylar() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {
        token: Store.state.tokenId,
      };
      soap.createClient(url, function (err, client) {
        client.rpAcikFaturaAylar(args, function (err, result) {
          if (result.rpAcikFaturaAylarResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          try {
            vm.veriler = JSON.parse(result.rpAcikFaturaAylarResult);
            vm.rowDataAylar = vm.veriler;
          } catch (error) {}
        });
      });
    },
    rpAcikFaturalar() {
      var vm = this;
      const soap = require("soap");
      const url = state.sistemAddress;
      var args = {
        token: Store.state.tokenId,
      };
      soap.createClient(url, function (err, client) {
        client.rpAcikFaturalar(args, function (err, result) {
          if (result.rpAcikFaturalarResult == "-1") {
            Store.dispatch("logout");
            //this.$store.dispatch('login', payload)
          }

          try {
            vm.veriler = JSON.parse(result.rpAcikFaturalarResult);
            vm.rowData = vm.veriler;
          } catch (error) {}
        });
      });
    },
  },

  beforeMount() {
    this.columnDefs = [
      {
        width: 100,
        field: "",
        cellRendererFramework: "FinansalRaporDetayButon",
      },
      {
        headerName: "Cari No",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        field: "ACTNO",
      },
      {
        headerName: "Cari Adı",
        field: "ACTNAME",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },

      {
        headerName: "Bakiye",
        field: "BAKIYE",
        sortable: true,
        filter: "agDateColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: (params) => this.currencyFormatter(params.data.BAKIYE, "₺"),
        type: "rightAligned",
      },
    ];
    this.columnDefsAylar = [
      {
        width: 100,
        field: "",
        cellRendererFramework: "FinansalRaporAylikDetayButon",
      },
      {
        headerName: "Yıl",
        field: "YIL",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
      },
      {
        headerName: "Ay",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        field: "AY",
      },
      {
        headerName: "Tutar",
        field: "TUTAR",
        sortable: true,
        filter: "agTextColumnFilter",
        filterParams: { buttons: ["apply", "reset"], closeOnApply: true },
        valueFormatter: (params) => this.currencyFormatter(params.data.TUTAR, "₺"),
        type: "rightAligned",
      },
    ];
  },
};
</script>
